import script from "./ScraperLogApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScraperLogApp.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"ScraperLogApp.vue"]])

export default __exports__